"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedContributorSchema = exports.ContributorIMSchema = exports.ContributorSchema = exports.SubmittedContributorSchema = exports.ContributorTypeSchema = exports.SignoffStatusSchema = void 0;
const z = __importStar(require("zod"));
const disclosure_1 = require("./disclosure");
const disclosure_enums_1 = require("../enums/disclosure-enums");
exports.SignoffStatusSchema = z.nativeEnum(disclosure_enums_1.SignoffStatus);
exports.ContributorTypeSchema = z.nativeEnum(disclosure_enums_1.ContributorType);
exports.SubmittedContributorSchema = z.object({
    Name: z.string().min(1),
    // Trim: JotForm emails arrive with stray whitespace, which fails .email() downstream
    Email: z.string().trim().min(1),
    'Contribution %': z.string(),
});
exports.ContributorSchema = z.object({
    id: z.string(),
    name: z.string().min(1),
    email: z.string().trim().email(),
    contribution: z.number(),
    signoffStatus: exports.SignoffStatusSchema,
    disclosureId: z.string(),
    reason: z.string().nullable(),
    type: exports.ContributorTypeSchema,
});
exports.ContributorIMSchema = exports.ContributorSchema.omit({
    id: true,
});
/**
 * RelatedContributorSchema contains all relations on your model in addition to the scalars
 *
 * NOTE: Lazy required in case of potential circular dependencies within schema
 */
exports.RelatedContributorSchema = z.lazy(() => exports.ContributorSchema.extend({
    Disclosure: disclosure_1.DisclosureSchema,
}));
